<template>
  <div class="system-manage">
    <h1 class="system-manage__title">菜单管理</h1>
    <div class="system-manage__card">
      <el-form :inline="true" :model="query" size="small" class="system-manage__filters" @submit.native.prevent="search">
        <el-form-item label="菜单名称"><el-input v-model.trim="query.name" placeholder="请输入菜单名称或权限标识" clearable @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="状态"><el-select v-model="query.status" placeholder="全部" clearable><el-option label="启用" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="search">查询</el-button><el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button></el-form-item>
      </el-form>
    </div>
    <div class="system-manage__card">
      <div class="system-manage__toolbar"><el-button v-if="can('system:menu:add')" type="primary" icon="el-icon-plus" size="small" @click="openCreate()">新增菜单</el-button><el-button icon="el-icon-refresh" size="small" :loading="loading" @click="fetchMenus">刷新</el-button></div>
      <el-table v-loading="loading" :data="filteredTree" row-key="id" default-expand-all :tree-props="{ children: 'children' }">
        <el-table-column prop="name" label="菜单名称" min-width="205" show-overflow-tooltip><template slot-scope="{ row }"><i v-if="row.icon" :class="row.icon" /> {{ row.name }}</template></el-table-column>
        <el-table-column label="类型" width="90" align="center"><template slot-scope="{ row }"><el-tag :type="row.type === 2 ? 'warning' : row.type === 0 ? '' : 'success'" size="small">{{ typeLabel(row.type) }}</el-tag></template></el-table-column>
        <el-table-column prop="path" label="路由路径" min-width="180" show-overflow-tooltip />
        <el-table-column prop="permission" label="权限标识" min-width="210" show-overflow-tooltip />
        <el-table-column prop="sortOrder" label="排序" width="70" align="center" />
        <el-table-column label="状态" width="85" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag></template></el-table-column>
        <el-table-column label="内置" width="70" align="center"><template slot-scope="{ row }">{{ row.builtIn ? '是' : '否' }}</template></el-table-column>
        <el-table-column label="操作" width="235" align="center" fixed="right"><template slot-scope="{ row }"><div class="system-manage__actions">
          <el-button v-if="can('system:menu:edit')" type="text" size="small" @click="openEdit(row)">编辑</el-button>
          <el-button v-if="can('system:menu:add')" type="text" size="small" :disabled="row.type === 2" @click="openCreate(row)">新增下级</el-button>
          <el-button v-if="can('system:menu:delete')" type="text" size="small" class="system-manage__danger" :disabled="row.builtIn || deleting" @click="removeMenu(row)">删除</el-button>
        </div></template></el-table-column>
      </el-table>
    </div>

    <el-dialog :title="editingId ? '编辑菜单' : '新增菜单'" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="menuForm" :model="form" :rules="rules" label-width="95px" class="system-manage__form">
        <el-form-item label="上级菜单" prop="parentId"><el-cascader v-model="form.parentId" :options="parentOptions" :props="{ value: 'id', label: 'name', children: 'children', emitPath: false, checkStrictly: true }" filterable :show-all-levels="false" placeholder="请选择上级菜单" /></el-form-item>
        <el-form-item label="菜单类型"><el-radio-group v-model="form.type" @change="changeType"><el-radio :label="0">目录</el-radio><el-radio :label="1">菜单</el-radio><el-radio :label="2">按钮</el-radio></el-radio-group></el-form-item>
        <el-form-item label="菜单名称" prop="name"><el-input v-model.trim="form.name" maxlength="64" /></el-form-item>
        <el-form-item v-if="form.type !== 2" label="路由路径" prop="path"><el-input v-model.trim="form.path" maxlength="200" placeholder="以 / 开头，例如 /users" /><p class="system-manage__hint">菜单路径需对应系统已有页面；目录可不填写。</p></el-form-item>
        <el-form-item label="权限标识" prop="permission"><el-input v-model.trim="form.permission" maxlength="128" placeholder="例如 system:user:list" /><p class="system-manage__hint">按钮必须填写唯一权限标识，并与服务端接口权限一致。</p></el-form-item>
        <el-form-item v-if="form.type !== 2" label="菜单图标"><el-input v-model.trim="form.icon" maxlength="64" placeholder="例如 el-icon-user"><i v-if="form.icon" slot="prefix" :class="form.icon" /></el-input></el-form-item>
        <el-row :gutter="20"><el-col :span="12"><el-form-item label="排序"><el-input-number v-model="form.sortOrder" :min="0" :max="99999" controls-position="right" /></el-form-item></el-col><el-col :span="12"><el-form-item label="状态"><el-radio-group v-model="form.status"><el-radio :label="1">启用</el-radio><el-radio :label="0">禁用</el-radio></el-radio-group></el-form-item></el-col></el-row>
        <p v-if="form.builtIn" class="system-manage__hint">内置菜单不可删除，修改后会影响系统访问权限。</p>
      </el-form>
      <span slot="footer"><el-button @click="dialogVisible = false">取消</el-button><el-button type="primary" :loading="saving" v-permission="editingId ? 'system:menu:edit' : 'system:menu:add'" @click="save">确定</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getCurrentUser, hasPermission } from '@/utils/auth'

const newForm = () => ({ parentId: '', name: '', type: 0, permission: '', path: '', icon: '', sortOrder: 0, status: 1 })

export default {
  name: 'InTransitMenuManage',
  data() {
    const pathValidator = (rule, value, callback) => {
      if (this.form.type === 1 && !value) return callback(new Error('请输入菜单路由路径'))
      callback(value && !/^\/[^\s?#]*$/.test(value) ? new Error('路由路径须以 / 开头，不能包含空格、查询参数或锚点') : undefined)
    }
    const permissionValidator = (rule, value, callback) => callback(this.form.type === 2 && !value ? new Error('请输入按钮权限标识') : undefined)
    return {
      query: { name: '', status: '' }, appliedQuery: { name: '', status: '' },
      menus: [], loading: false, requestId: 0, dialogVisible: false, editingId: null, saving: false, deleting: false, form: newForm(),
      rules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        path: [{ validator: pathValidator, trigger: 'blur' }],
        permission: [{ validator: permissionValidator, trigger: 'blur' }]
      }
    }
  },
  computed: {
    filteredTree() {
      const tree = this.buildTree(this.menus)
      const query = this.appliedQuery
      const prune = nodes => nodes.reduce((result, node) => {
        const children = prune(node.children || [])
        const matches = (!query.name || `${node.name} ${node.permission || ''}`.toLowerCase().includes(query.name.toLowerCase())) && (query.status === '' || node.status === query.status)
        if (matches || children.length) result.push({ ...node, children })
        return result
      }, [])
      return prune(tree)
    },
    parentOptions() {
      const excluded = new Set()
      if (this.editingId) {
        excluded.add(String(this.editingId))
        const collect = id => this.menus.filter(menu => String(menu.parentId) === String(id)).forEach(menu => { if (!excluded.has(String(menu.id))) { excluded.add(String(menu.id)); collect(menu.id) } })
        collect(this.editingId)
      }
      const eligible = this.menus.filter(menu => menu.type !== 2 && !excluded.has(String(menu.id)))
      return [{ id: '', name: '顶级目录' }, ...this.buildTree(eligible)]
    }
  },
  created() { this.fetchMenus() },
  beforeDestroy() { this.requestId += 1 },
  methods: {
    can(code) { return hasPermission(code) },
    typeLabel(type) { return { 0: '目录', 1: '菜单', 2: '按钮' }[type] || '-' },
    search() { this.appliedQuery = { ...this.query } },
    resetQuery() { this.query = { name: '', status: '' }; this.search() },
    buildTree(menus) {
      const nodes = new Map(menus.map(menu => [String(menu.id), { ...menu, children: [] }]))
      const roots = []
      nodes.forEach(menu => { const parent = nodes.get(String(menu.parentId)); if (parent) parent.children.push(menu); else roots.push(menu) })
      const sort = items => { items.sort((a, b) => a.sortOrder - b.sortOrder); items.forEach(item => { if (item.children.length) sort(item.children); else delete item.children }) }
      sort(roots)
      return roots
    },
    async fetchMenus() {
      const id = ++this.requestId
      this.loading = true
      try { const response = await request.get('/webserver/system/menus'); if (id === this.requestId) this.menus = response.data }
      catch (error) { if (id === this.requestId) this.$message.error(error.msg || '读取菜单失败') }
      finally { if (id === this.requestId) this.loading = false }
    },
    openCreate(parent) { this.editingId = null; this.form = { ...newForm(), parentId: parent ? parent.id : '', type: parent ? 1 : 0 }; this.dialogVisible = true; this.$nextTick(() => this.$refs.menuForm.clearValidate()) },
    openEdit(row) { this.editingId = row.id; this.form = { ...row, parentId: row.parentId || '' }; this.dialogVisible = true; this.$nextTick(() => this.$refs.menuForm.clearValidate()) },
    changeType() { if (this.form.type === 2) { this.form.path = ''; this.form.icon = '' } this.$nextTick(() => this.$refs.menuForm.clearValidate()) },
    save() {
      this.$refs.menuForm.validate(async valid => {
        if (!valid || this.saving) return
        this.saving = true
        try {
          const payload = { parentId: this.form.parentId || null, name: this.form.name, type: this.form.type, permission: this.form.permission, path: this.form.type === 2 ? '' : this.form.path, icon: this.form.type === 2 ? '' : this.form.icon, sortOrder: this.form.sortOrder, status: this.form.status }
          if (this.editingId) await request.put(`/webserver/system/menus/${this.editingId}`, payload)
          else await request.post('/webserver/system/menus', payload)
          this.$message.success('菜单已保存')
          this.dialogVisible = false
          await this.fetchMenus()
          await getCurrentUser(true)
        } catch (error) { this.$message.error(error.msg || '保存菜单失败') }
        finally { this.saving = false }
      })
    },
    async removeMenu(row) {
      if (this.deleting || row.builtIn) return
      try {
        await this.$confirm(`确认删除菜单“${row.name}”吗？有下级或被角色使用的菜单不能删除。`, '删除菜单', { type: 'warning' })
        this.deleting = true
        await request.delete(`/webserver/system/menus/${row.id}`)
        this.$message.success('删除成功')
        await this.fetchMenus()
        await getCurrentUser(true)
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '删除菜单失败') }
      finally { this.deleting = false }
    }
  }
}
</script>

<style src="./system-manage.css"></style>
